import { axios } from '~/clients';
import { WHY_BUY } from '~/constants/endpoints';
import type { YmmtWhyBuy } from '~/contracts/vdp';

export default function fetchWhyBuyData(
  kbbVehicleId: number,
  controller: AbortController
) {
  return axios
    .get<YmmtWhyBuy>(`${WHY_BUY}?kbbVehicleId=${kbbVehicleId}`, {
      signal: controller.signal
    })
    .then(res => res.data);
}
